export default __webpack_public_path__ + "static/media/image_1.d86171d3.webp";